import { render, staticRenderFns } from "./RbuItemExtra.vue?vue&type=template&id=1e8ee226"
import script from "./RbuItemExtra.vue?vue&type=script&lang=js"
export * from "./RbuItemExtra.vue?vue&type=script&lang=js"
import style0 from "./RbuItemExtra.vue?vue&type=style&index=0&id=1e8ee226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports